<template>
    <div>
        <h5>All Existing Themes</h5>
        <!-- Use of custom tree table for Theme -->
        <custom-tree-table :treeTableValue="themeTreeTable" entity="Theme" @editOperation="editTheme" @deleteOperation="themeStore.deleteTheme" />

        <!-- Theme edit form -->
        <theme-form v-if="editDialogForm" @hide-dialog="editDialogForm = false" />
    </div>
</template>
<script setup>
import { themeStore } from '../../../../../store/global-stores';
import CustomTreeTable from '../../../components/CustomTreeTable.vue';
import ThemeForm from './ThemeForm.vue';
import { storeToRefs } from 'pinia';
import { ref, onMounted } from 'vue';

const { themeTreeTable } = storeToRefs(themeStore);
const editDialogForm = ref(false);

onMounted(() => {
    themeStore.fetchAllThemes();
});

const editTheme = (theme) => {
    themeStore.createEditThemeBody(theme);
    editDialogForm.value = true;
};
</script>
